import { useState } from 'react';
import { ARROW_DIRECTION_DOWN, CollapsibleContentArrow } from 'ui/collapsibleContent';
import { JsonView } from 'ui/treeView';
import { ArrowButton, ExpandedCell, NameCellWrapper } from './Styled';

type NameCellProps = {
  name: string;
  data: Record<string, any>;
};

export const NameCell = ({ name, data }: NameCellProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <>
      <NameCellWrapper>
        <div>{name}</div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ArrowButton onClick={() => setIsCollapsed((collapsedState) => !collapsedState)}>
            <CollapsibleContentArrow
              isCollapsed={isCollapsed}
              arrowStart={ARROW_DIRECTION_DOWN}
              arrowEnd={180}
              width={16}
              height={16}
            />
          </ArrowButton>
        </div>
      </NameCellWrapper>
      {isCollapsed ? null : (
        <ExpandedCell>
          <JsonView collapseByDefault src={data} />
        </ExpandedCell>
      )}
    </>
  );
};
